import React from "react";
import { SocketProvider } from "../../components/providers/SocketProvider";
import EventsLeaderboard from "./EventsLeaderboard";
import Leaderboard from "../leagues/Leaderboard";

type propsType = {
  leaderBoardType: "event" | "league-tournament";
};

const LeaderBoardProvider = ({ leaderBoardType }: propsType) => {
  return (
    <SocketProvider>
      {leaderBoardType == "event" ? <EventsLeaderboard /> : <Leaderboard />}
    </SocketProvider>
  );
};

export default LeaderBoardProvider;
